<script>
import PromoCard from "./promo/PromoCard.vue";
import {
  getPromoEntry,
  updatePromoEntry,
  claimPromoSlot,
  hasCreatedProofs,
} from "./promo/promoState.js";
import { PLAN_SKU_TYPES } from "../../utils/constants";

const PROMO_ID = "google-review";
const CHECKED_KEY = "google-review-promo::checkedThisSession";
const ELIGIBLE_KEY = "google-review-promo::eligible";
// Ashore's Google Business Profile review link. Leave empty to keep the promo off.
const REVIEW_URL = "https://g.page/r/Cf0hKyXwkXbKEAI/review";
const MAX_SHOWS = 3;
const MIN_PROOFS = 20;

export default {
  name: "GoogleReviewPromoCard",
  components: { PromoCard },
  data() {
    return {
      show: false,
    };
  },
  async mounted() {
    if (!REVIEW_URL) return;
    // Paying customers only — free users get the Starter upgrade promo instead
    const sku = _.get(window, "$A.Auth.account.subscriptionState.sku", "");
    if (!sku || sku.split("-")[0] === PLAN_SKU_TYPES.FREE_PLAN) return;
    const entry = await getPromoEntry(PROMO_ID);
    if (!entry || entry.converted || entry.dismissed) return;
    if (entry.showCount >= MAX_SHOWS) return;
    if (!(await hasCreatedProofs(MIN_PROOFS, ELIGIBLE_KEY, CHECKED_KEY))) return;
    if (!claimPromoSlot()) return;
    this.show = true;
    updatePromoEntry(PROMO_ID, { incrementShowCount: true });
  },
  methods: {
    dismiss() {
      this.show = false;
      updatePromoEntry(PROMO_ID, { dismissed: true });
    },
    leaveReview() {
      this.show = false;
      updatePromoEntry(PROMO_ID, { converted: true });
      window.open(REVIEW_URL, "_blank", "noopener");
    },
  },
};
</script>

<template>
  <PromoCard
    :show="show"
    aria-label="Google review request"
    eyebrow="Enjoying Ashore?"
    title="Tell others about your experience"
    cta-text="Leave a review"
    dismiss-label="Dismiss"
    @dismiss="dismiss"
    @cta="leaveReview"
  >
    <template #eyebrow-icon>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    </template>
    You've approved a lot of proofs with us. A quick Google review takes a minute
    and helps other creative teams find Ashore.
  </PromoCard>
</template>
